import { Component, ReactNode } from 'react';
import { Link, useLocation, useMatch } from 'react-router-dom';
import { Row, Col, Container } from 'react-bootstrap';
import algorandLogo from '../../assets/images/algorandlogo.png';

const Footer = () => {
  const location = useLocation();

  return (
    <Container className="footer">
      <Row>
        <Col className="footer-col col-12">
          <div className="header-container">
            <Link to="/">
              <div style={{ transform: 'skewX(10deg)' }}>
                <i
                  className="fas fa-home"
                  style={{
                    color: 'rgb(150,155,150)',
                  }}
                />
              </div>
            </Link>
            <Link to="terms" className={location.pathname === '/terms' ? 'navbar-item-active' : ''}>
              <div style={{ transform: 'skewX(10deg)' }}>Terms</div>
            </Link>
            <Link
              to="privacy"
              className={location.pathname === '/privacy' ? 'navbar-item-active' : ''}
            >
              <div style={{ transform: 'skewX(10deg)' }}>Privacy</div>
            </Link>
            <Link to="faq" className={location.pathname === '/faq' ? 'navbar-item-active' : ''}>
              <div style={{ transform: 'skewX(10deg)' }}>FAQ</div>
            </Link>
            <Link
              to="contact"
              className={location.pathname === '/contact' ? 'navbar-item-active' : ''}
            >
              <div style={{ transform: 'skewX(10deg)' }}>Contact</div>
            </Link>
            <Link to="about" className={location.pathname === '/about' ? 'navbar-item-active' : ''}>
              <div style={{ transform: 'skewX(10deg)' }}>About</div>
            </Link>
          </div>
        </Col>
      </Row>
      <Row className="justify-content-end">
        <Col style={{ textAlign: 'right' }} xs="auto">
          &copy; 2022 PURRSER
        </Col>
        <Col
          style={{
            fontSize: '0.65rem',

            textAlign: 'right',
            height: '20px',
          }}
        >
          built on
          <img height="20px" src={algorandLogo} alt="algorand" />{' '}
        </Col>
      </Row>
    </Container>
  );
};

export default Footer;
